import React from 'react';
import {HOST_NAME} from '../../constants';
type FeatureImageProps = {
    image: string;
    title: string;
    desktop?: boolean;
    clickHandler?: () => void
}

export const FeatureImage = (props: FeatureImageProps) => {
    const { image, title, desktop, clickHandler } = props;
    let classes = 'event-feature-image container';

        if (desktop) {
           classes = `${classes} desktop`;
        }

    return (<div className={classes} onClick={clickHandler}>

        <img

            src={image}
            alt={title} title={title}
            className='event-feature-image'/>
    </div>)
}
